import { withLoader } from 'util/routeHelper';
import { openMessageModal } from 'actions/modal';

export default store => ({
	path: 'signup',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'Signup',
				),
			store,
			'SIGNUP',
		),
	},
	onEnter: () => {
		store.dispatch(openMessageModal('loginSignup', { type: 'newPassword' }));
	},
});



// WEBPACK FOOTER //
// ./src/routes/Signup/index.js